import classNames from 'classnames';
import { FC, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useResponsive } from 'v3/common/hooks/useResponsive';

type PortalToTargetProps = {
  children?: React.ReactNode;
  targetClassName?: string;
  insertIndex?: number;
  className?: string;
  allowForWeb?: boolean;
};

const PortalToTarget: FC<PortalToTargetProps> = ({
  children,
  targetClassName = 'body',
  insertIndex = -1,
  className = '',
  allowForWeb = false,
}) => {
  const isMobile = useResponsive();

  const [container, setContainer] = useState<HTMLElement | null>(null);
  const placeholderRef = useRef<HTMLDivElement | null>(null);
  const combinedClassName = classNames('insertion-wrapper', className);

  useEffect(() => {
    const targetElements = document.getElementsByClassName(targetClassName);
    const targetElement = targetElements[0];

    if (!targetElement) return;

    const placeholder = document.createElement('div');
    placeholder.className = combinedClassName;
    placeholderRef.current = placeholder;

    // Insert at specific index or append
    if (insertIndex >= 0 && insertIndex < targetElement.children.length) {
      targetElement.insertBefore(placeholder, targetElement.children[insertIndex]);
    } else {
      targetElement.appendChild(placeholder);
    }
    setContainer(placeholder);

    return () => {
      if (placeholder && placeholder.parentNode) {
        placeholder.parentNode.removeChild(placeholder);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetClassName, insertIndex]);

  if (!isMobile && !allowForWeb) return children;
  if (!container) return null;

  return createPortal(children, container);
};

export default PortalToTarget;
